import React from "react";
import ReactModal from "react-modal";

import FileViewer from "./FileViewer";

import { V2 } from "../Api";

import "./PhotoRoll.css";

interface IFileViewDialogProps {
    isOpen: boolean;

    fileId: string;
    description?: string | React.ReactChild;

    onRequestClose?: (event?: (React.MouseEvent | React.KeyboardEvent)) => void;
}

interface IFileViewDialogState {
    isLoading: boolean | string;

    url: string;
    mime: string;
}

class FileViewDialog extends React.Component<IFileViewDialogProps, IFileViewDialogState> {
    constructor(props: Readonly<IFileViewDialogProps>) {
        super(props);

        const state: IFileViewDialogState = {
            isLoading: true,

            url: "",
            mime: "",
        };

        this.state = state;
    }

    public componentDidMount() {
        this.loadFile();
    }

    public componentWillUnmount() {
        if (this.state.url) {
            URL.revokeObjectURL(this.state.url);
        }
    }

    public componentDidUpdate(prevProps: Readonly<IFileViewDialogProps>) {
        if (prevProps.fileId !== this.props.fileId) {
            this.loadFile();
        }
    }

    public render() {
        if (!this.props.isOpen) {
            return null;
        }

        return (
            <ReactModal
                isOpen={this.props.isOpen} onRequestClose={this.props.onRequestClose}
                overlayClassName="modal-overlay" className="modal-content modal-viewer-content photo-viewer-modal" portalClassName="modal-viewer-portal"
                bodyOpenClassName="modal-viewer-open"
                contentLabel="Image Viewer">
                {this.state.isLoading === true
                    ? <div className="spinner spinner-center lds-dual-ring" />
                    : typeof this.state.isLoading === "string"
                        ? <div className="error-text">{this.state.isLoading}</div>
                        : <FileViewer className="photo-viewer" url={this.state.url} mime={this.state.mime} />
                }
                {/*
                <div className="photo-description">
                    {this.state.viewerDescription}
                    {!!this.props.canDelete
                        ? <OverflowMenuItem dropdownClassName="toolbar-menu-up-left" className="button btn-light small">
                            <button type="button" onClick={this.handleDelete}><i className="icon-trash" /><span>Delete image</span></button>
                        </OverflowMenuItem>
                        : null
                    }
                </div>
                */}
            </ReactModal>
        );
    }

    private async loadFile() {
        if (!this.props.fileId) {
            return;
        }

        try {
            if (this.state.url) {
                URL.revokeObjectURL(this.state.url);
            }

            const file = await V2.get<Blob>(`files/${this.props.fileId}`);
            const blob = URL.createObjectURL(file);

            this.setState({
                isLoading: false,

                url: blob,
                mime: file.type
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || e || "Could not load file"
            });
        }
    }
}

export default FileViewDialog;
